import {css} from "lit";

export const loadingBoxStyles = css`
	.loading-box-overlay {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: var(--pn-loading-box-overlay-bg-color);
		opacity: 0.6;
		z-index: 99;
		display: flex;
		align-items: center;
	}

	.loading-box {
		display: flex;
		width: 100%;
		text-align: center;
	}

	.loading-box .animation {
		position: relative;
		height: 14px;
		margin: auto;
	}

	.loading-box .animation .animation-item {
		display: inline-block;
		top: 0;
		width: 14px;
		height: 14px;
		background-color: var(--pn-loading-box-dot-color-start);
		animation-name: loading;
		animation-duration: 1.5s;
		animation-iteration-count: infinite;
		animation-direction: normal;
		border-radius: calc(var(--pn-border-radius-base) + 2px);
	}

	.loading-box .animation .animation-item:not(:last-child) {
		margin-right: 16px;
	}

	// Item
	.animation-item-1 {
		animation-delay: 0.6s;
	}
	.animation-item-2 {
		animation-delay: 0.75s;
	}
	.animation-item-3 {
		animation-delay: 0.9s;
	}
	.animation-item-4 {
		animation-delay: 1.05s;
	}

	// Text
	.loading-box .animation span {
		font-family: var(--pn-font-family-base);
	}

	@keyframes loading {
		50% {
			background-color: var(--pn-loading-box-dot-color-end);
		}
	}
`;
